"use client"
import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";

const TagSelector = ({ defaultOptions, defaultValue, onSelect, onBlur }) => {
  const targetHeight = 38;

  const customStyles = {
    control: base => ({
      ...base,
      minHeight: "initial"
    }),
    valueContainer: base => ({
      ...base,
      height: `${targetHeight - 1 - 1}px`,
      padding: "0 8px"
    }),
    clearIndicator: base => ({
      ...base,
      padding: `${(targetHeight - 20 - 1 - 1) / 2}px`
    }),
    dropdownIndicator: base => ({
      ...base,
      padding: `${(targetHeight - 20 - 1 - 1) / 2}px`
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };

  const components = {
    DropdownIndicator: null
  };

  const createOption = label => ({
    label,
    value: label
  });

  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState([]);

  useEffect(() => {
    if (defaultOptions) {
      setOptions(defaultOptions.map(o => createOption(o)));
    }
  }, [defaultOptions]);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue.map(o => createOption(o)));
    }
  }, [defaultValue]);

  const handleSelect = value => {
    setValue(value);
    if (onSelect) {
      if (value) {
        onSelect(value.map(v => v.value));
      } else {
        onSelect([]);
      }
    }
  };

  const handleKeyDown = event => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        handleSelect(
          value
            ? value.concat([createOption(inputValue)])
            : [createOption(inputValue)]
        );
        setInputValue("");
        event.preventDefault();
    }
  };

  return (
    <CreatableSelect
      components={components}
      styles={customStyles}
      inputValue={inputValue}
      isClearable
      isMulti
      // menuIsOpen={options && options.length > 0}
      options={options}
      onChange={newValue => handleSelect(newValue ?? [])}
      onInputChange={newValue => setInputValue(newValue)}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      placeholder="Type something and press enter..."
      value={value}
    />
  );
};
export default TagSelector;
